import React from 'react';
import PropTypes from 'prop-types';
import PharmacySearch from 'components/Pharmacy/PharmacySearch';
import Icon from 'components/Utils/NewIcon';

const PharmacySearchModal = ({
  backButton,
  initialPharmacies,
  onSelect,
  onClose,
  defaultPharmacyId,
}) => (
  <div className="modal pharmacy-search-modal">
    <div className="title">
      {!!backButton && (
        <div onClick={backButton} className="back-button">
          <Icon src="arrow-left" />
        </div>
      )}
      {!!onClose && (
        <div onClick={onClose} className="back-button">
          <Icon src="xmark" />
        </div>
      )}
      Pharmacies
    </div>
    <div className="content">
      <PharmacySearch
        onSelect={onSelect}
        initialPharmacies={initialPharmacies}
        defaultPharmacyId={defaultPharmacyId}
      />
    </div>
  </div>
);

PharmacySearchModal.propTypes = {
  backButton: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  initialPharmacies: PropTypes.array,
  defaultPharmacyId: PropTypes.string,
};

export default PharmacySearchModal;
